import { FilterWithOperation, IFilterTagData } from './TagsFilter/types';

export function OnTagFilterChange(
  tagsFilterData: IFilterTagData[],
  doneCb: (tags: IFilterTagData[]) => void,
): (tagOrArrTagAndOp: FilterWithOperation) => void {
  return tagOrArrTagAndOp => {
    const [tagOrArrTag, operation] = tagOrArrTagAndOp;
    if (tagOrArrTag instanceof Array) {
      // Makes next lookup fast
      const tagArrMap = tagOrArrTag.reduce((acc, current) => {
        acc[current.id] = current;
        return acc;
      }, {} as { [tagId: string]: IFilterTagData });

      let filtered = tagsFilterData.filter(tag => {
        return !tagArrMap[tag.id];
      });

      if (operation === 'ADD') {
        filtered = [...filtered, ...tagOrArrTag];
      }

      doneCb(filtered);
    } else {
      let filtered = tagsFilterData.filter(tag => {
        return tag.id !== tagOrArrTag.id;
      });
      if (operation === 'ADD') {
        filtered = [...filtered, tagOrArrTag];
      }
      doneCb(filtered);
    }
  };
}
